import UserAvatarFromName from 'components/Common/UserAvatarFromName';
import { getLastMessages } from 'helpers/fakebackend_helper';
import { React ,useState, useEffect } from 'react'
import { useQuery } from 'react-query';
import { Card, CardBody, CardTitle, Container, Row, Col, Spinner, Button } from "reactstrap";
import { Link } from 'react-router-dom';

export default function PopularCandidates() {
  const [visibleCandidates, setVisibleCandidates] = useState([])

  const { data, isLoading } = useQuery('last_messages', getLastMessages, {
    staleTime: 120000,
      refetchOnWindowFocus: false,
    });

  return (
    <Container className="bg-white p-4 rounded">
      <h4 className="card-title mb-4">Member Messages</h4>
      <div className="mb-4" />

      {isLoading ? ( // Check if loading
        <div className="d-flex justify-content-center"><Spinner color="primary" /></div> // Show loader
      ) : data?.latest_messages?.length === 0 ? ( // Check if there are no messages
        <div className="text-center">
          <div>No messages available. Start a conversation with your space members!</div>
          <div><Link to="/chat"  style={{ backgroundColor: "#2F8C47" }} className="btn btn-primary mt-2 btn-sm">View Messages</Link></div>
        </div> 
      ) : (
        data?.latest_messages?.slice(0, 2)?.map((candidate) => (
          <Card key={candidate.id} className="mb-4 bg-light">
            <CardBody className="p-4">
              <Row>
                <Col xs="auto">
                  <UserAvatarFromName name={candidate.sender_name} size="sm" />
                </Col>
                <Col  className="d-flex justify-content-between align-items-center">
                  <CardTitle tag="h5">{candidate.sender_name}</CardTitle>
                </Col>
                <Col >
                <div className="text-muted">{new Date(candidate.created_at).toLocaleDateString([], {  month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</div>
                </Col>
              </Row>
              <Row>
                <Col xs="12" className="mt-3">
                  <div className="text-muted mx-4 font-bold">{candidate.message}</div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        ))
      )}
    </Container>
  )
}